import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ComponentType } from '@angular/cdk/portal';
import {
  ToastNotificationComponent,
  ToastData,
} from '../components/toast-notification/toast-notification.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  private defaultConfig: MatSnackBarConfig = {
    duration: 6000,
    horizontalPosition: 'end',
    verticalPosition: 'top',
    panelClass: ['app-toast-panel'],
  };

  success(message: string, title?: string) {
    this.showToast({ message, title, type: 'success' });
  }

  error(message: string, title?: string) {
    this.showToast({ message, title, type: 'error' });
  }

  info(message: string, title?: string) {
    this.showToast({ message, title, type: 'info' });
  }

  warn(message: string, title?: string) {
    this.showToast({ message, title, type: 'warn' });
  }

  private showToast(data: ToastData) {
    this.snackBar.openFromComponent(ToastNotificationComponent, {
      ...this.defaultConfig,
      data,
    });
  }

  // Optional: for custom components inside snackbar
  openFromComponent<T>(component: ComponentType<T>, config?: MatSnackBarConfig) {
    return this.snackBar.openFromComponent(component, {
      ...this.defaultConfig,
      ...config,
    });
  }
}
